import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { text: "Blogs", to: "/blogs" },
    { text: "How It Works", to: "/#how-it-works" },
    { text: "Benefits", to: "/#benefits" },
    { text: "FAQ", to: "/#faq" },
    { text: "Download", to: "/#download" },
  ];

  return (
    <nav className="nav-header">
      <div className="nav-content">
        <Link to="/" className="nav-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_decision-helper-app/artifacts/4ptnwsm9_fc_flower_blue.png" 
            alt="Find Clarity Logo" 
            className="logo-image"
          />
          <span className="logo-text">FindClarity</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-links-desktop">
          {navLinks.map((link, index) => (
            <Link key={index} to={link.to} className="nav-link">
              {link.text}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="nav-links-mobile">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              className="nav-link-mobile"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.text}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
